<h2 class="title h2">{{ 'batchs.tabs.USED_INTERVALS' | translate }}</h2>
<app-generic-table
    [tableConfig]="tableConfig"
></app-generic-table>
